import React from "react";
import { Link } from "react-router-dom";
import { Video, Shirt } from "lucide-react";

/**
 * BookNowBanner — two-card CTA placed above the footer on the home page.
 * Card A routes to virtual styling consult; Card B to stylist session.
 */
export default function BookNowBanner() {
  return (
    <section
      className="px-6 md:px-12 lg:px-24 py-16 bg-gradient-to-b from-[hsl(var(--kb-surface-alt))] via-white to-[hsl(var(--kb-surface))]"
      data-testid="home-book-now-banner"
    >
      <div className="grid md:grid-cols-2 border border-[hsl(var(--kb-border))] bg-white divide-y md:divide-y-0 md:divide-x divide-[hsl(var(--kb-border))]">
        {/* Card A — Shop Via Video Call */}
        <div className="p-10 md:p-14 flex flex-col items-center text-center">
          <div className="w-16 h-16 rounded-full bg-[hsl(var(--kb-surface-alt))] flex items-center justify-center mb-6 text-[hsl(var(--kb-primary))]">
            <Video size={28} strokeWidth={1.5} />
          </div>
          <h3 className="font-display text-3xl md:text-4xl text-[hsl(var(--kb-primary))]">
            Shop Via Video Call
          </h3>
          <p className="text-sm md:text-base text-[hsl(var(--kb-muted))] mt-3 max-w-sm">
            Get a free virtual styling session with our experts.
          </p>
          <Link
            to="/account?tab=appointments&book=virtual_consult"
            className="mt-8 inline-block px-10 py-3 bg-white border border-[hsl(var(--kb-primary))] text-[hsl(var(--kb-primary))] text-xs uppercase tracking-[0.2em] hover:bg-[hsl(var(--kb-primary))] hover:text-white transition-colors"
            data-testid="home-book-video-call"
          >
            Book an Appointment
          </Link>
        </div>

        {/* Card B — The Bridal Stylist */}
        <div className="p-10 md:p-14 flex flex-col items-center text-center bg-[hsl(var(--kb-surface))]">
          <div className="w-16 h-16 rounded-full bg-white flex items-center justify-center mb-6 text-[hsl(var(--kb-primary))]">
            <Shirt size={28} strokeWidth={1.5} />
          </div>
          <h3 className="font-display text-3xl md:text-4xl text-[hsl(var(--kb-primary))]">
            The Bridal Stylist
          </h3>
          <p className="text-sm md:text-base text-[hsl(var(--kb-muted))] mt-3 max-w-sm">
            Book your personal bridal consultation and find the perfect wedding look.
          </p>
          <Link
            to="/account?tab=appointments&book=stylist_session"
            className="mt-8 inline-block px-10 py-3 bg-white border border-[hsl(var(--kb-primary))] text-[hsl(var(--kb-primary))] text-xs uppercase tracking-[0.2em] hover:bg-[hsl(var(--kb-primary))] hover:text-white transition-colors"
            data-testid="home-book-bridal-stylist"
          >
            Book an Appointment
          </Link>
        </div>
      </div>
    </section>
  );
}
